import React, { Component } from "react";
import PlatformSidebar from "./PlatformSidebar";
import "./Videos.css";
import VideosHome from "./VideosHome";
import Onboarding from "./Onboarding.js";
import AddFunds from "./AddFunds.js";
import ImportFromPassword from "./ImportFromPassword";
import TransactionStatus from "./TransactionStatus";
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import HyperaceConnectWalletModal from "./HyperaceConnectWalletModal";
import { CgSpinner } from "react-icons/cg";
import logo from './logo.png';
import Auction from './Auction';
import AuctionSkeleton from './AuctionSkeleton';
import AuctionNFT from './AuctionNFT';
import nounsglasses from "./glasses-deep-teal.png";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import {IoMdArrowRoundBack} from "react-icons/io";
import { nounsAuctionHouseContractAddress, mainnetNounsAuctionHouseContractAddress } from "./config";

const contract = require("./artifacts/contracts/NounsAuctionHouse.sol/NounsAuctionHouse.json");

let web3;
let usedContractAddress;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetNounsAuctionHouseContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = nounsAuctionHouseContractAddress;
}

class ContinuousAuction extends Component {
  constructor(props) {
    super(props);
    this.fetchInfo = this.fetchInfo.bind(this);
    this.selectModal = this.selectModal.bind(this);
    this.setTransactionStatus = this.setTransactionStatus.bind(this);
    this.startFirstAuction = this.startFirstAuction.bind(this);

    this.state = {
      collectionDetails: null,
      isLoaded: false,
      modalShown: "",
      transactionStatus: "None",
      hasAddedListeners: false,
      hasClickedStartFirstAuction: false,
      shouldShowSpinnerUntilFirstAuctionLoads: false,
    };
  }

  async componentDidMount() {
    let urlSplit = window.location.href.split("/");
    let collectionId = urlSplit[urlSplit.length - 1];
    if (collectionId.includes("?autorefresh=true")) {
      collectionId = collectionId.split("?autorefresh=true")[0];
      let self = this;
      async function waitUntilLoaded() {
        return await new Promise((resolve) => {
          const interval = setInterval(async () => {
            if (self.state.collectionDetails != null) {
              resolve();
              clearInterval(interval);
            } else {
              await self.fetchInfo();
            }
          }, 2000);
        });
      }
      waitUntilLoaded();
    } else {
      await this.fetchInfo();
    }
  }

  async fetchInfo() {
    let urlSplit = window.location.href.split("/");
    let collectionId = urlSplit[urlSplit.length - 1];
    let isAutorefresh = collectionId.includes("?autorefresh=true");
    collectionId = collectionId.split("?autorefresh=true")[0];
    let collectionDetails = await encryptUtils.getNounsCollectionDetails(collectionId);

    this.setState({
      collectionDetails,
      isLoaded: collectionDetails != null || !isAutorefresh
    });

    let self = this;
    if(!self.state.hasAddedListeners) {
      const nounsAuctionHouseContract = new web3.eth.Contract(contract.abi, usedContractAddress);
      nounsAuctionHouseContract.events
        .AuctionCreated()
        .on("data", function (event) {
          let data = event.returnValues;
          console.log(data);
          if (parseInt(data["collectionId"]) !== parseInt(collectionId)) {
            return;
          }
          self.setState({
            transactionStatus: "Start Auction Complete",
          });
        })
        .on("error", function (event) {
          self.setState({
            transactionStatus: "Failed",
          });
        });
      nounsAuctionHouseContract.events
        .AuctionSettled()
        .on("data", function (event) {
          let data = event.returnValues;
          console.log(data);
          if (parseInt(data["collectionId"]) !== parseInt(collectionId)) {
            return;
          }
          if (
            self.props.account == null ||
            data["sender"].toLowerCase() !== self.props.account.address.toLowerCase()
          ) {
            return;
          }
          self.setState({
            transactionStatus: "Settle Auction Complete",
          });
        })
        .on("error", function (event) {
          self.setState({
            transactionStatus: "Failed",
          });
        });
      nounsAuctionHouseContract.events
        .AuctionBid()
        .on("data", function (event) {
          let data = event.returnValues;
          console.log(data);
          if (parseInt(data["collectionId"]) !== parseInt(collectionId)) {
            return;
          }
          if (
            self.props.account == null ||
            data["sender"].toLowerCase() !== self.props.account.address.toLowerCase()
          ) {
            return;
          }
          self.setState({
            transactionStatus: "Create Bid Complete",
          });
        })
        .on("error", function (event) {
          self.setState({
            transactionStatus: "Failed",
          });
        });
        self.setState({
          hasAddedListeners: true,
        });
      loggingUtils.logEvent(
        this.props.account != null
          ? this.props.account.address
          : encryptUtils.getWalletUnconnectedUserId(),
        "auction_page",
        "auction_page_load",
        "info",
        "https://the402.xyz",
        {}
      );
    }
  }

  setTransactionStatus(status) {
    this.setState({
      transactionStatus: status,
    });
  }

  async startFirstAuction() {
    if(this.props.account == null) {
      return;
    }
    this.setState({
      hasClickedStartFirstAuction: true,
    });
    this.setTransactionStatus("Pending");
    let didApprove = await encryptUtils.startFirstAuction(this.props.account.address, this.state.collectionDetails);
    if(!didApprove) {
      this.setTransactionStatus("None");
    }
    else {
      loggingUtils.logEvent(
        this.props.account != null
          ? this.props.account.address
          : encryptUtils.getWalletUnconnectedUserId(),
        "auction_page",
        "auction_page_start_first_auction",
        "info",
        "https://the402.xyz",
        {}
      );
      this.setState({
        shouldShowSpinnerUntilFirstAuctionLoads: true,
      })
      let self = this;
      async function waitUntilLoaded() {
        return await new Promise((resolve) => {
          const interval = setInterval(async () => {
            if (self.state.collectionDetails.latestAuction != null) {
              resolve();
              clearInterval(interval);
              self.setState({
                shouldShowSpinnerUntilFirstAuctionLoads: false,
              });
            } else {
              await self.fetchInfo();
            }
          }, 2000);
        });
      }
      waitUntilLoaded();
    }
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  render() {
    // TODO undo immigrant parents hard coding
    return (
      <div>
        <div>
          <PlatformSidebar
            modalShown={this.state.modalShown}
            selectModal={this.selectModal}
          />
        </div>
        {
          this.state.collectionDetails != null && this.state.collectionDetails["latestAuction"] != null
            ?
          <div className="min-h-screen bg-custom-white dark:bg-custom-black">
          <div
            onClick={() => {
              window.open(window.location.origin + "/nounsupload", "_self");
            }}
            className="font-nouns md:visible invisible absolute right-12 top-20 cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 ml-2 w-20 md:w-40 h-14 flex justify-center items-center text-lg font-bold bg-black dark:bg-white rounded-xl dark:text-black text-white">
            <img className="h-8" src={nounsglasses} />
              <div className="mx-2">
              Create
              </div>
          </div>
            <div>
              <div className="ml-16 pt-20 flex">
                <div className="w-8 h-8 bg-gray-200 dark:bg-zinc-800 hover:bg-gray-300 duration-500 rounded-full cursor-pointer">
                  <IoMdArrowRoundBack
                    className="text-3xl dark:text-gray-400 text-gray-600"
                    onClick={
                      () => {
                        loggingUtils.logEvent(
                          this.props.account != null
                            ? this.props.account.address
                            : encryptUtils.getWalletUnconnectedUserId(),
                          "auction_page",
                          "auction_page_return_to_auction_collections",
                          "info",
                          "https://the402.xyz",
                          {}
                        );
                        window.location.href = window.location.origin + "/auctioncollections";
                      }
                    }
                  />
                </div>
                <div className="ml-2 text-2xl font-semibold dark:text-white">
                  {
                    this.state.collectionDetails["latestAuction"]["name"].includes("Immigrant Parents")
                      ?
                    "Immigrant Parents (live with the402)"
                      :
                    this.state.collectionDetails["latestAuction"]["name"]
                  }
                </div>
              </div>
              <div className="border-2 dark:border-zinc-800 rounded-md w-48 h-10 justify-center flex items-center ml-24 font-semibold text-gray-500 dark:text-zinc-500 mt-2" >
                { "Treasury: " + Math.round(this.state.collectionDetails["treasury"] * 1000) / 1000 + " ETH" }
              </div>
              <div className="w-screen justify-center flex">
                {
                  this.state.collectionDetails["latestAuction"] != null
                    ?
                  <Auction
                    collectionDetails={this.state.collectionDetails}
                    account={this.props.account}
                    setTransactionStatus={this.setTransactionStatus}
                    isFromCollections={false}
                  />
                    :
                  null
                }
              </div>
              <div className="mt-8 w-screen border-t-2 dark:border-t-2 dark:border-zinc-800 flex justify-center">
                <div className="w-11/12 justify-center flex">
                  <div>
                    <div className="text-2xl font-nouns font-normal flex w-full justify-center text-gray-500 font-semibold dark:text-zinc-500 mt-8">
                      Settled NFTs
                    </div>
                    <div className="grid grid-cols-1 xl:grid-cols-3 xl:gap-2 lg:grid-cols-3 lg:gap-4">
                      {
                        this.state.collectionDetails["allAuctions"].map(auction => {
                          if(auction["nounId"] === this.state.collectionDetails["latestAuction"]["nounId"]) {
                            return null;
                          } else {
                            return <AuctionNFT key={auction["nounId"]} auction={auction} account={this.props.account} />
                          }
                        })
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            :
          this.state.isLoaded && this.state.collectionDetails != null
            ?
          <AuctionSkeleton
            hasClickedStartFirstAuction={this.state.hasClickedStartFirstAuction}
            startFirstAuction={this.startFirstAuction}
            shouldShowSpinnerUntilFirstAuctionLoads={this.state.shouldShowSpinnerUntilFirstAuctionLoads}
          />
            :
          !this.state.isLoaded
            ?
          <div className="min-h-screen bg-custom-white dark:bg-custom-black flex justify-center items-center">
            <CgSpinner size={70} className="loading-spinner" color="gray" />
          </div>
            :
          <div className="min-h-screen bg-custom-white dark:bg-custom-black flex justify-center items-center">
          </div>
        }
        {this.state.modalShown === "createAccount" ? (
          <Onboarding selectModal={this.selectModal} />
        ) : this.state.modalShown === "addFunds" ? (
          <AddFunds selectModal={this.selectModal} />
        ) : this.state.modalShown === "importFromPassword" ? (
          <ImportFromPassword selectModal={this.selectModal} />
        ) : null}
        <TransactionStatus
          transactionStatus={this.state.transactionStatus}
          item={this.state.collectionDetails}
        />
      </div>
    );
  }
}

export default ContinuousAuction;
